import React, { useMemo } from "react";
import { rankWith, schemaMatches } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import { useTranslation } from "react-i18next";
import SFRadioGroup from "../../radioGroup";

const RadioRenderer = ({
  data,
  handleChange,
  path,
  uischema,
  schema,
  errors,
}) => {
  const { t } = useTranslation();

  const onChange = (e) => {
    const value = e.target.value;
    handleChange(path, value);
  };

  const RADIOS = useMemo(() => {
    return schema?.anyOf?.map((option) => ({
      label: option?.i18nKey ? t(option?.i18nKey) : option?.label,
      value: option.value,
      disabled: uischema?.options?.readonly ?? false,
    }));
  }, [schema]);

  // The currently selected value
  const selectedValue = data ?? schema?.anyOf[0]?.value;
  const labelProps = {variant: "formElementLabel", color: "grey400"};

  return (
    <SFRadioGroup
      optionsInNewRow={uischema?.optionsInNewRow}
      name={path}
      label={uischema?.i18nKey ? t(uischema?.i18nKey) : uischema?.label}
      radios={RADIOS}
      value={selectedValue}
      labelVariant={labelProps.variant}
      labelColor={labelProps.color}
      onChange={onChange}
    />
  );
};

export const RadioTester = rankWith(
  141,
  schemaMatches((schema) => schema.radio === true)
);

export default withJsonFormsControlProps(RadioRenderer);
